export default __webpack_public_path__ + "74c9d442839b0942f054f2055795f836.png";